<template>
  <div id="siteBreadcrumb">
    <div class="container">
      <div class="site-breadcrumb col-12 q-mb-md">
        <q-breadcrumbs class="text-grey" active-color="primary">
          <template v-slot:separator>
            <q-icon size="1em" name="arrow_forward" color="primary" class="site-breadcrumb--icon" />
          </template>

          <q-breadcrumbs-el :key="key" :icon="bread.icon || undefined" v-for="(bread, key) in list" :label="bread.name" :href="generateURL(bread.link || '')" />
        </q-breadcrumbs>
      </div>
    </div>
  </div>
  <!--  <div class="page-header dtable text-center" style="background-image: url('/img/bg-page-header.jpg')">-->
  <!--    <div class="dcell">-->
  <!--      <div class="container">-->
  <!--        <h1 v-if="siteBreadcrumbs.length" class="page-title">-->
  <!--          {{ siteBreadcrumbs[siteBreadcrumbs.length - 1].name }}-->
  <!--        </h1>-->
  <!--        <ul id="breadcrumbs" class="breadcrumbs">-->
  <!--          <li>-->
  <!--            <a href="./"><i class="fas fa-home"></i></a>-->
  <!--          </li>-->
  <!--          <template :key="key" v-for="(bread, key) in siteBreadcrumbs">-->
  <!--            <li v-if="bread.link">-->
  <!--              <a :href="bread.link">{{ bread.name }}</a>-->
  <!--            </li>-->
  <!--            <li v-else class="active">{{ bread.name }}</li>-->
  <!--          </template>-->
  <!--        </ul>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useMeta } from 'quasar';
import { PageStore } from 'stores/Page/Page.ts';
import { storeToRefs } from 'pinia';

export default defineComponent({
  name: 'Breadcrumb',

  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
  },

  inject: ['siteBreadcrumbs'],

  setup(props) {
    const pageStore = PageStore();
    const { head, breadcrumbs } = storeToRefs(pageStore);

    const useBreadcrumbs = props.modelValue.length > 0 ? props.modelValue : breadcrumbs.value;

    if (!useBreadcrumbs.find((b) => b.icon === 'home')) {
      useBreadcrumbs.unshift({
        icon: 'home',
        name: 'Anasayfa',
        link: '/',
      });
    }

    const cleanSiteAddress = (head.value?.title?.siteAddress || '').endsWith('/')
      ? head.value.title.siteAddress.slice(0, -1)
      : head.value?.title?.siteAddress || '';

    useMeta({
      script: {
        schemaBreadcrumbs: {
          type: 'application/ld+json',
          innerHTML: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: useBreadcrumbs.map((item, index) => ({
              '@type': 'ListItem',
              position: index + 1,
              name: item.name,
              item: `${cleanSiteAddress}${generateURL(item.link || '/')}`,
            })),
          }),
        },
      },
    });

    function generateURL(link: string) {
      if (link !== '/' && !link.startsWith('/')) {
        return `/${link}`;
      }

      return link;
    }

    return {
      list: useBreadcrumbs,
      generateURL,
    };
  },
});
</script>

<style scoped>
#siteBreadcrumb {
  font-size: 0.9rem;
  margin: 0.2rem 0 1.25rem;
}

#siteBreadcrumb .site-breadcrumb--icon {
  position: relative;
  top: -0.04rem;
}
</style>
